module.exports = __webpack_public_path__ + "static/media/aws academy.1ca4bfe3.png";